import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MonthYear } from '../../custom-month-year-picker/custom-month-year-picker.component';
import { ToastrService } from 'ngx-toastr';
import { catchError, forkJoin, of } from 'rxjs';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';
import { CONSTANTS } from 'src/Core/Constant';
import { environment } from 'src/environments/environment';
import { TranslationService } from 'src/app/Service/translation.service';

@Component({
  selector: 'app-personal-detail',
  templateUrl: './personal-detail.component.html',
  styleUrls: ['./personal-detail.component.scss']
})
export class PersonalDetailComponent {

  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Input() applicantData: any; // Accept data from parent component
  @Input() isPreviewMode: boolean = false; // Flag to determine behavior
  personalDetailsForm!: FormGroup;
  submitted = false;
  SaveMode = CONSTANTS.SAVE_MODE;
  isJsonShow = environment.isJsonShow;  // Set isJsonShow from the environment
  currentAge: string = ''; // Property to store calculated age (not part of form)
  selectedLanguage: string = 'en';
  isEditable: boolean = true; // Flag to track if the form is editable


  constructor(private fb: FormBuilder,private toastr: ToastrService,private api : SevaProfileService, public genericValidations: GenericValidationsService, private translationService: TranslationService) {
    this.maxDate = new Date();
  }

  maxDate: Date;
  years: number[] = []; // Array to hold the list of years



  ngOnInit(): void {
  
    if (!this.isPreviewMode) {
      // Execute only when not in preview mode
      this.initializeForm();
      this.years = this.genericValidations.generateYearRange();
      this.fetchInitialData();
    }

    // Load saved language preference
    this.selectedLanguage = this.translationService.getCurrentLanguage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicantData'] && this.applicantData) {

      this.initializeForm();
      this.patchFormWithApplicantData(this.applicantData);
      this.personalDetailsForm.disable();
    }
  }

  patchFormWithApplicantData(data: any): void {
    if (data) {
      // Handle any necessary data formatting before patching
      if (data.DateOfBirth) {
        // Keep DateOfBirth as a Date object for the custom date picker
        data.DateOfBirth = new Date(data.DateOfBirth);
        // Calculate age when patching data
        this.calculateAge(data.DateOfBirth);
      }
      if (data.LastStayDate) {
        // Convert string format (e.g., "6-2025") to MonthYear object for the custom picker
        if (typeof data.LastStayDate === 'string' && data.LastStayDate.includes('-')) {
          const [month, year] = data.LastStayDate.split('-').map(Number);
          data.LastStayDate = {
            month: month,
            year: year
          };
        } else if (data.LastStayDate instanceof Date) {
          // If it's a Date object, convert to MonthYear
          data.LastStayDate = {
            month: data.LastStayDate.getMonth(),
            year: data.LastStayDate.getFullYear()
          };
        }
        // If it's already a MonthYear object, keep as is
      }
      this.personalDetailsForm.patchValue(data);
    }
  }



  fetchInitialData() {


    this.getApplicantData();

  }
  



/**
   * Handles gender code change for preset gender values
   * @param value - Selected gender code
   */
// onGenderCodeChange(event: Event): void {
//   const selectElement = event.target as HTMLSelectElement;
//   const value = selectElement.value;
//   const genderControl = this.personalDetailsForm.get('Gender');

//   if (value === 'M') {
//     genderControl?.setValue('Male');
//     genderControl?.clearValidators();
//   } else if (value === 'F') {
//     genderControl?.setValue('Female');
//     genderControl?.clearValidators();
//   } else if (value === 'O') {
//     genderControl?.setValue(''); // Clear value if 'Other' is selected
//     genderControl?.setValidators([Validators.required]);
//   } else if (value === '') {
//     // When "Select Gender" is selected, clear the gender field and remove validators
//     genderControl?.setValue('');
//     genderControl?.clearValidators();
//   }
//   genderControl?.updateValueAndValidity();
// }


  getApplicantData(){
    this.api.apiCall('PersonalDetail/GetPersonalDetails', 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%

        // Store IsEditable flag from response
        this.isEditable = response.Data.IsEditable !== false; // Default to true if not provided

        // Disable form if not editable
        if (!this.isEditable) {
          this.personalDetailsForm.disable();
        } else {
          this.personalDetailsForm.enable();
        }

        // this.genericValidations.setProgressPercentage(response.Data.CompletionPercentage); // Example: Set progress to 50%


      if (response.Data.DateOfBirth) {
        // Keep DateOfBirth as a Date object for the custom date picker
        response.Data.DateOfBirth = new Date(response.Data.DateOfBirth);
      }

      if (response.Data.LastStayDate) {
        // Convert string format (e.g., "6-2025") to MonthYear object for the custom picker
        if (typeof response.Data.LastStayDate === 'string' && response.Data.LastStayDate.includes('-')) {
          const [month, year] = response.Data.LastStayDate.split('-').map(Number);
          response.Data.LastStayDate = {
            month: month,
            year: year
          };
        } else if (response.Data.LastStayDate instanceof Date) {
          // If it's a Date object, convert to MonthYear
          response.Data.LastStayDate = {
            month: response.Data.LastStayDate.getMonth(),
            year: response.Data.LastStayDate.getFullYear()
          };
        }
        // If it's already a MonthYear object, keep as is
      }
            
        this.personalDetailsForm.patchValue(response.Data);
      }
    })
  }




  initializeForm() {
    this.personalDetailsForm = this.fb.group({
      FirstName: ['', [Validators.required, this.genericValidations.noWhitespaceValidator]],
      LastName: ['', [Validators.required, this.genericValidations.noWhitespaceValidator]],
      MiddleName: ['', [Validators.required, this.genericValidations.noWhitespaceValidator]],
      // Occupation: ['', [Validators.required, this.genericValidations.noWhitespaceValidator]],
      Gender: [''],
      GenderCode: ['', Validators.required],

      DateOfBirth: ['', Validators.required],
      MaritalStatus: ['', Validators.required],
      BeforeMarriageFullName: ['',],
      IsFirstStay: ['', Validators.required],
      // PracticeYear: ['', Validators.required],
      LastStayDate: [null, Validators.required],
      // IsAggrementAccepted: [true],
      SaveMode: ['', Validators.required]
    });

    // Set up listener for Date of Birth changes to auto-calculate age
    this.personalDetailsForm.get('DateOfBirth')?.valueChanges.subscribe(dateOfBirth => {
      if (dateOfBirth) {
        this.calculateAge(dateOfBirth);
      } else {
        this.currentAge = '';
      }
    });

    const controlMappings = {
      'IsFirstStay': ['LastStayDate'],
      'isIso450012018cert': ['certificationDate', 'renewalDate']
    };
 
  // Call the service with the isShowOn parameter set to true or false as needed
  this.genericValidations.setupFormListeners(this.personalDetailsForm, controlMappings,   false);
  
    this.formGroupChange.emit(this.personalDetailsForm);
  }

  // Calculate age from date of birth
  calculateAge(dateOfBirth: string | Date): void {
    if (!dateOfBirth) {
      this.currentAge = '';
      return;
    }
  
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
  
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();
  
    // Adjust for negative days
    if (days < 0) {
      months--;
      // Get number of days in the previous month
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }
  
    // Adjust for negative months
    if (months < 0) {
      years--;
      months += 12;
    }
  
    // Format result same as .NET (e.g., "25 Years, 3 Months, 10 Days")
    this.currentAge = `${years} Years, ${months} Months, ${days} Days`;
  }

  // PersonalDetail/SavePersonalDetails




onSubmit(Mode: number): void {

  // const practiceYearValue = this.personalDetailsForm.get('PracticeYear')?.value;


if (!this.personalDetailsForm.valid && Mode ==  this.SaveMode.SAVE) {
  this.submitted = true;


    // Add 'submitted' class manually to all invalid controls
    Object.keys(this.personalDetailsForm.controls).forEach((field) => {
      const control = this.personalDetailsForm.get(field);
      if (control && control.invalid) {
        control.markAsTouched(); // Ensure ng-touched is triggered
        const element = document.getElementById(field);
        if (element) {
          element.classList.add('submitted'); // Add 'submitted' class to invalid elements
        }
      }
    });


    this.toastr.warning('Please complete all required fields before submitting.');
  return
}


const formData = this.personalDetailsForm.value;

// Convert DateOfBirth back to Date object before sending to the backend
if (formData.DateOfBirth) {
  formData.DateOfBirth = new Date(formData.DateOfBirth); // Convert back to Date object
}


// Convert LastStayDate MonthYear object to string format before sending to backend
if (formData.LastStayDate && typeof formData.LastStayDate === 'object' && 'month' in formData.LastStayDate) {
  // Convert MonthYear object to string format (e.g., "6-2025")
  const monthYear = formData.LastStayDate as MonthYear;
  formData.LastStayDate = `${monthYear.month}-${monthYear.year}`;
} else if (formData.LastStayDate) {
  // If it's already a string or other format, keep as is
  formData.LastStayDate = formData.LastStayDate;
}

if(formData.LastStayDate == "" || formData.LastStayDate == null){
  formData.LastStayDate = null
}


const cleanedValues = this.genericValidations.removeWhitespaceFromValues(this.personalDetailsForm.value);
this.addUpdate(cleanedValues, Mode);



}


addUpdate(reqBoby: any, Mode: number) {
  reqBoby.SaveMode = Mode;
  this.api.apiCall('PersonalDetail/SavePersonalDetails', 'POST', reqBoby).subscribe((response: any) => {
    console.log('POST response:', response);
    this.toastr.success( response?.Message);
    if (Mode ==  this.SaveMode.SAVE) {
      this.nextStep.emit();
    }else if(Mode ==  this.SaveMode.DRAFT){
      this.getApplicantData();
    }
  });
}


  goToBack() {
    this.previous.emit();
  }

  // getPracticeYearControl(): FormControl {
  //   return this.personalDetailsForm.get('PracticeYear') as FormControl;
  // }

  getLastStayDateControl(): FormControl {
    return this.personalDetailsForm.get('LastStayDate') as FormControl;
  }

  // Translations
  getTranslation(key: string): string {
    return this.translationService.getTranslation(key);
  }
}
